/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-03-11 14:30:38
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-06-18 11:04:57
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/main.js
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
 */
import App from './App.vue'
import { createApp } from 'vue'
import { setupVab } from '@/vab'
import { setupStore } from '@/store'
import { setupRouter } from '@/router'
import './registerServiceWorker'
/**
 * @description 正式环境默认使用mock，正式项目记得注释后再打包
 */
import { baseURL, pwa } from './config'
// import { isExternal } from '@/utils/validate'

const app = createApp(App)
import VueUeditorWrap from 'vue-ueditor-wrap'
app.use(VueUeditorWrap)

import BCodeEditor from 'bin-code-editor'
import 'bin-code-editor/lib/styles/index.css'

app.use(BCodeEditor)
// if (process.env.NODE_ENV === 'production' && !isExternal(baseURL)) {
//   const { mockXHR } = require('@/utils/static')
//   mockXHR()
// }

if (pwa) require('./registerServiceWorker')

/**
 * @description 生产环境启用组件初始化，编译，渲染和补丁性能跟踪。仅在开发模式和支持 Performance.mark API的浏览器中工作。
 */
if (process.env.NODE_ENV === 'development') {
  app.config.performance = true
}

// 全局挂载map
app.config.globalProperties.$Map = window.TMap
app.config.globalProperties.$Location = new window.qq.maps.Geolocation(
  'SR2BZ-QH4C4-EHJUP-D7TOD-MKQAQ-WUB2A',
  '腾讯地图模板'
)

import mitt from 'mitt'
app.config.globalProperties.mittBus = mitt()

setupVab(app)
setupStore(app)
setupRouter(app)
  .isReady()
  .then(() => app.mount('#app'))
